module.exports = __webpack_public_path__ + "static/img/yycj_07.a6bd2c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_07.png
// module id = aBEY
// module chunks = 2